import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import Header from "./Header";
import Footer from "./Footer";
import "../style/NotFoundScreen.css";

/**
 * With content bundled at build time there is no "could not load" state left.
 * The one real failure is asking for a project that does not exist, so the
 * message says exactly that instead of a generic error.
 */
export default function NotFoundScreen() {
  const { lang } = useLanguage();

  return (
    <>
      <Header />
      <main className="not-found">
        <h1>{lang === "en" ? "Page not found" : "Sayfa bulunamadı"}</h1>
        <p>
          {lang === "en"
            ? "This project may have been removed, or the address may be mistyped."
            : "Bu proje kaldırılmış ya da adres yanlış yazılmış olabilir."}
        </p>
        <Link to="/">{lang === "en" ? "Go to all projects" : "Tüm projelere git"}</Link>
      </main>
      <Footer />
    </>
  );
}
